import { render } from "./PlusExtension.vue?vue&type=template&id=01a716b9"
import script from "./PlusExtension.vue?vue&type=script&lang=js"
export * from "./PlusExtension.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__